import { generatePath, Params } from 'react-router';

export const url = (url: string, params?: Params) => {
  return generatePath(url, params);
};
